module.exports = __webpack_public_path__ + "img/image152.53cb891d.jpg";